module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Chuck-Taylors-Web-640.79e93c11.jpg";